import Swiper, { Navigation, EffectCards } from 'swiper';

function achievementsChoicer() {
  const entity = document.getElementById('achievements-choicer');
  const link = document.getElementById('achievements-downloader');
  if (!entity || !link) return null;

  new Swiper(entity, { // eslint-disable-line
    modules: [EffectCards, Navigation],
    effect: 'cards',
    cardsEffect: {
      rotate: true,
    },
    grabCursor: true,
    initialSlide: 0,
    speed: 500,
    loop: true,
    mousewheel: {
      invert: false,
    },
    navigation: {
      nextEl: entity.querySelector('.swiper-button-next'),
      prevEl: entity.querySelector('.swiper-button-prev'),
    },
    on: {
      init: function () {
        this.el.classList.remove('swiper');
        this.slides.forEach((slide) => {
          const img = slide.querySelector('img');
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          const name = img.dataset.name;
          const color = String(img.dataset.color);
          if (!color) return;
          const image = new Image();
          image.crossOrigin = '*';
          image.src = img?.src;
          image.onload = function () {
            ctx.drawImage(image, 0, 0);
            ctx.font = 'bold 65px Roboto';
            ctx.fillStyle = color;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';
            ctx.fillText(name, canvas.width / 2, canvas.height / 2 + 40);
            canvas.toBlob(
              (blob) => {
                const imageUrl = URL.createObjectURL(blob);
                img.src = imageUrl;
                if (slide.classList.contains('swiper-slide-active')) {
                  link.download = name;
                  link.href = imageUrl;
                }
              },
              'image/jpeg',
              0.9,
            );
          };
        });
      },
      activeIndexChange: function () {
        const activeSlide = this.slides[this.activeIndex];
        link.download = activeSlide?.querySelector('img')?.dataset?.name || 'User Name';
        link.href = activeSlide?.querySelector('img')?.src || '/';
      },
    },
  });

  return null; // eslint-disable-line
}

export default achievementsChoicer;
